// extracted by mini-css-extract-plugin
export var card = "_qn-0";
export var content = "_qn-2";
export var details = "_qn-3";
export var icon = "_qn-1";
export var iconBlue = "_qn-5";
export var iconBrand = "_qn-4";
export var iconGrayBlue = "_qn-6";
export var iconGreen = "_qn-7";
export var iconIndigo = "_qn-8";
export var iconOrange = "_qn-9";
export var iconPurple = "_qn-a";
export var iconRed = "_qn-b";
export var iconWarning = "_qn-c";